function* authSaga() {
  //  Coming soon auth
}

export default authSaga;
